import React from "react";
import autobind from "class-autobind";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaTrashAlt, FaCopy } from "react-icons/fa";

interface Props {
  baseURL: string;
  values: DineInTable[];
  onChange: (values: DineInTable[]) => void;
}

export class FieldDineInTables extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
    autobind(this);
  }

  copy(i: number) {
    const values = [ ...this.props.values ];
    const value = { ...values[i] };
    values.push(value);
    this.props.onChange(values);
  }

  remove(i: number) {
    const values = ([ ...this.props.values ]);
    values.splice(i, 1);
    this.props.onChange(values);
  }

  change(i: number, key: keyof DineInTable, value: string) {
    const values = [ ...this.props.values ];
    values[i][key] = value;
    this.props.onChange(values);
  }

  render() {
    const { values, baseURL } = this.props;
    return (
      <div>
        { values.map((item, i) => {
          let url = "";
          if (item.name && item.password) {
            url = baseURL + `?table_id=${item._id}&table_pw=${item.password}`;
          }
          else if (item.name) {
            url = baseURL + `?table_id=${item._id}`;
          }
          return (
            <div key={i} className="flex-line" style={{ alignItems: "flex-end" }}>

              <InputBox className="no-round width64 text-center">
                <p className="big font-bold" style={{ lineHeight: "36px" }}>{i + 1}</p>
              </InputBox>

              <div className="flex-line" style={{ alignItems: "flex-end" }}>
                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Table Name" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="text"
                    className="no-round"
                    style={{ width: "150px" }}
                    value={item.name}
                    onChange={(e) => this.change(i, "name", e.target.value)}/>
                </FormGroup>
                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Table Password" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="text"
                    className="no-round"
                    style={{ width: "150px" }}
                    value={item.password}
                    onChange={(e) => this.change(i, "password", e.target.value)}/>
                </FormGroup>
                <FormGroup
                  className="m-b-0"
                  title={i === 0 ? "Order URL" : null}
                  small_title={true}
                  no_border={true}>
                  <Input
                    type="text"
                    className="no-round"
                    style={{ width: "150px" }}
                    value={url}
                    readOnly={true}
                    onFocus={(e) => e.target.select()}
                  />
                </FormGroup>
              </div>

              <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.remove(i)}>
                <FaTrashAlt/>
              </Button>
              <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => this.copy(i)}>
                <FaCopy/>
              </Button>

            </div>
          );
        })}

      </div>
    );
  }
}
